import { render, staticRenderFns } from "./DownlineBioInfo.vue?vue&type=template&id=3690b59c&"
import script from "./DownlineBioInfo.vue?vue&type=script&lang=js&"
export * from "./DownlineBioInfo.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/profile.css?vue&type=style&index=0&lang=css&"
import style1 from "./DownlineBioInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports